import styled from '@emotion/styled'

import sanitizeHtml from 'sanitize-html'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { type PageConfig, usePageConfig } from '@segment/contexts/page'

import RichCustomerProfilesImage from './RichCustomerProfilesImage'

const getCopy = (pageConfig: PageConfig) => ({
  heading: `Rich customer profiles in your warehouse`,
  description: `Segment makes it easier to merge and sync customer profiles with your warehouse. With 
  <a href="${getAbsoluteUrl(
    `/product/profiles-sync/`,
    pageConfig
  )}">Segment Profile Sync</a>, you get a clear structured view of your profiles and a log showing how they were created and combined in the warehouse. This offers full visibility right where your data team needs it.`,
})

export const RichCustomerProfiles = () => {
  const pageConfig = usePageConfig()

  const { heading, description } = getCopy(pageConfig)
  return (
    <StyledSectionBase variant="2Col" copyVariant="narrow" reverse={true}>
      <Section.Copy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h3">{heading}</CopyText.Heading>
          <CopyText.Description
            tag="p"
            variant="pLarge"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(description, { allowedTags: [`a`] }),
            }}
          />
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <RichCustomerProfilesImage />
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  justify-content: center;

  ${Section.Wrapper} {
    row-gap: 64px;
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-bottom: 160px;
    }
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-bottom: 0;
    }
  }
`

export default RichCustomerProfiles
